export default __webpack_public_path__ + "447f07f0e17bbf8b8ebbd94f8930d756.ttf";